import {css, html, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators.js';
import {styleMap} from "lit-html/directives/style-map.js";

@customElement('sp-percentage-indicator')
export class SpPercentageIndicator extends LitElement {
    static styles =
        // language=CSS
        css`
        :host {
            display: block;
            position: relative;
            aspect-ratio: 1;
        }
        
        .container {
            display: flex;
            justify-content: center;
            align-items: center;
            font-family: 'EkMukta-SemiBold';
            color: white;
            width: 100%;
            height: 100%;
            border-radius: 50%;
        }
        
        .text {
            margin-top: 0.1em;
            margin-left: 0.1em;
            white-space: nowrap;
        }

        .percentage, .percentage-sign {
            display: inline-block;
            vertical-align: baseline;
            box-sizing: content-box;
            line-height: 1;
        }
        
        .percentage {
            font-size: calc(var(--sp-font-size-default)*2);
        }
        
        .percentage-sign {
            font-size: calc(var(--sp-font-size-default)/1.8);
        }
    `;

    // Percentage in the range 0 - 1 (1 = 100%)
    @property()
    percentage: number = 0;

    @property()
    colorStages = [
        {
            val: 0.25,
            color: 'rgb(var(--sp-color-red))'
        },
        {
            val: 0.7,
            color: 'rgb(var(--sp-color-orange))'
        },
        {
            val: 1,
            color: 'rgb(var(--sp-color-green))'
        }
    ];

    protected render() {
        return html`
            <div class="container"
                 part="container"
                 style=${ styleMap({
                    backgroundColor: this.getColor()
                })}>
                    <div class="text">
                        <span class="percentage">${ (this.percentage * 100).toFixed(0) }</span><span class="percentage-sign" part="percentage-sign">%</span>
                    </div>

            </div>`;
    }

    getColor(): string {
        for (const stage of this.colorStages) {
            if (this.percentage <= stage.val)
                return stage.color
        }
        return this.colorStages[this.colorStages.length - 1].color;
    }
}
